export const CACHE_CLEAR = 'CACHE_CLEAR';
export const CACHE_SAVE = 'CACHE_SAVE';
export const ERROR_ADD = 'ERROR_ADD';
export const ERROR_CLEAR = 'ERROR_CLEAR';
export const CONNECTION_CHANGED = 'CONNECTION_CHANGED';
export const SET_TASK_OPTIMISTIC = 'SET_TASK_OPTIMISTIC';
export const CLEAR_TASK_OPTIMISTIC = 'CLEAR_TASK_OPTIMISTIC';
export const SET_SIGNALR_CONNECTION = 'SET_SIGNALR_CONNECTION';

//NEXUS
export const SET_AUTHENTICATION_STATE = 'SET_AUTHENTICATION_STATE';
